import { toExcerpt } from '../Common/useEntries';

const HTML_TAG = /<\/?[a-z][\s\S]*>/i;

/**
 * A plain-text summary of a consultation description, for cards and meta tags.
 * The CMS editor saves HTML (often pasted from Word, with <style> blocks and entities such as &ccedil;);
 * older posts are Markdown.
 */
export function descriptionSummary(description, length) {
    if (!description) return '';
    let text;
    if (HTML_TAG.test(description) && typeof DOMParser !== 'undefined') {
        // DOMParser builds an inert document: nothing in it runs or loads.
        const doc = new DOMParser().parseFromString(description, 'text/html');
        doc.querySelectorAll('style, script, template').forEach((node) => node.remove());
        // Keep words in separate blocks apart once tags are gone.
        doc.querySelectorAll('p, div, li, br, h1, h2, h3, h4, h5, h6, td, th, tr').forEach((node) => node.append(' '));
        text = doc.body.textContent || '';
    } else {
        text = description.replace(/[#*_>`~[\]]/g, '');
    }
    return toExcerpt(text, length);
}
